type Props = {
  color?: string;
};

/** A speech balloon with a star: what customers say. */
const TestimonialsIcon = ({ color = "currentColor" }: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={16} height={16} viewBox="0 0 16 16">
    <path
      fill={color}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 1.5A1.5 1.5 0 0 0 .5 3v7A1.5 1.5 0 0 0 2 11.5h1.5V14a.5.5 0 0 0 .82.38L7.78 11.5H14a1.5 1.5 0 0 0 1.5-1.5V3A1.5 1.5 0 0 0 14 1.5H2Zm6 2.1.86 1.74 1.92.28-1.39 1.35.33 1.91L8 7.98l-1.72.9.33-1.91-1.39-1.35 1.92-.28L8 3.6Z"
    />
  </svg>
);

export default TestimonialsIcon;
